import { Injectable } from '@angular/core';
import { AjaxDataServiceService } from '@admin/core/ajax-data-service.service';
import { UrlConfigContainer } from '@admin/core/url-config';
import { UrlConfigService } from '@hrra/core';
import { ActionResultModel } from '@admin/shared/models/action-result-model';
import { MonthlyPlan } from '../models/monthly-plan';
import { MonthlyPlanReport } from '../models/monthly-plan-report';

@Injectable()
export class MonthlyPlanService {
  constructor(
    private ajax: AjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>
  ) {}

  public getEmptyPlan() {
    return this.ajax.getData(
      this.urlService.urlConfig.api.data.sales.monthlyPlans.getEmptyPlan,
      null,
      MonthlyPlan
    );
  }

  public getEmptyPlanSpecific(
    year: number,
    month: number,
    portfolioId: number = null
  ) {
    let parameters = {
      year,
      month,
      portfolioId,
    };
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.sales.monthlyPlans.getEmptyPlanSpecific,
      parameters,
      MonthlyPlan
    );
  }

  public getCurrentPlan(portfolioId: number = null) {
    return this.ajax.getData(
      this.urlService.urlConfig.api.data.sales.monthlyPlans.getCurrentPlan,
      { portfolioId },
      MonthlyPlan
    );
  }

  public getPlan(year: number, month: number, portfolioId: number = null) {
    return this.ajax.getData(
      this.urlService.urlConfig.api.data.sales.monthlyPlans.getPlan,
      { year, month, portfolioId },
      MonthlyPlan
    );
  }

  public createPlan(plan: MonthlyPlan) {
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.sales.monthlyPlans.create,
      plan,
      ActionResultModel
    );
  }

  public editPlan(plan: MonthlyPlan) {
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.sales.monthlyPlans.edit,
      plan,
      ActionResultModel
    );
  }

  public getReport(year: number, month: number) {
    let params = {
      year,
      month,
    };
    return this.ajax.getData(
      this.urlService.urlConfig.api.data.sales.monthlyPlans.getReport,
      params,
      MonthlyPlanReport
    );
  }
}
